import { combineReducers, configureStore } from "@reduxjs/toolkit";

import modalStack from "../../slices/modalStack";

const excludeSerializableCheck = {
  serializableCheck: false,
};

const store = configureStore({
  reducer: combineReducers({ modalStack }),
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(excludeSerializableCheck),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
